import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  const isLive = location.hostname === 'app.dendagen.no';

  Sentry.init({
    dsn,
    environment: import.meta.env.PROD && !isLive ? 'preview' : import.meta.env.MODE,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      httpBodies: [],
    },
    integrations: [
      Sentry.browserTracingIntegration({
        ignoreResourceSpans: ['resource.script', 'resource.link', 'resource.css', 'resource.img', 'resource.other'],
        enableLongTask: false,
        enableLongAnimationFrame: false,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: isLive ? 0.1 : 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: isLive ? 1.0 : 0,
  });
}

export { Sentry };
